import type { PillProps } from "@validereinc/common-components";
import { TransactionType } from "@validereinc/domain";

export const FiltersConfig = {
  search_name: {
    name: "search_file_name",
    placeholder: "Search by file name",
    label: "File Name",
  },
  search_transaction: {
    name: "search_transaction_id",
    placeholder: "Search by transaction ID",
    label: "Transaction ID",
  },
  date: {
    name: "dateRange",
  },
  status: {
    name: "status",
    placeholder: "Select a status",
  },
  source: {
    name: "source",
    placeholder: "Select a Source",
    label: "Source",
  },
  dataset: {
    name: "dataset",
    placeholder: "Select a dataset",
    label: "Dataset",
  },
} as const;

export const getTransactionStatusVariant = (
  status?: TransactionType["status"]
): PillProps["variant"] => {
  switch (status) {
    case "completed":
      return "success";
    case "completed_with_partial_success":
      return "warning";
    case "pending":
      return "info";
    case "failed":
      return "error";
    default:
      return "default";
  }
};
